import { getMarginModeAggregateStatus } from 'helpers/utils';

import { useWalletStoreBase } from './wallet.store';
import { WalletStore } from './wallet.types';

// ======= Store Selectors - To be used with functions outside react (NON-REACTIVE) =======

// #region Store Selectors
const walletStoreSelector = () => useWalletStoreBase.getState().state;

const walletSpotPriceBySymbolSelector = (spotSymbol: string) =>
  walletStoreSelector().walletSpotPrice[spotSymbol];

// #endregion

// ========  Data Selectors - To be used with components (Reactive Data) ========
// Usage -> const multiCollateralData = useWalletStoreBase(selectCloseBySymbol(symbol));

// #region Reactive Data Selectors
const selectMultiCollateralData = (store: WalletStore) => store.state.multiCollateral;

const selectAvailableMarginCross = (store: WalletStore) =>
  store.state.available_margin_cross;

const selectPortfolioMargin = (store: WalletStore) => store.state.portfolio_margin;

const selectCrossMargin = (store: WalletStore) => store.state.crossMarginChannel;

// Note: use with useShallow
const selectBlockedMarginCrossModeUsd = (store: WalletStore) => {
  const { multiCollateral } = store.state;

  const blockedMarginCrossMode = (multiCollateral?.wallets ?? []).reduce(
    (acc, wallet) => {
      return (
        acc +
        parseFloat(String(wallet?.cross_position_margin ?? 0)) +
        parseFloat(String(wallet?.cross_order_margin ?? 0)) +
        parseFloat(String(wallet?.cross_commission ?? 0)) +
        parseFloat(String(wallet?.strategy_blocked_amount ?? 0))
      );
    },
    0
  );
  return blockedMarginCrossMode;
};

// Note: use with useShallow
const selectMarginModeAggregateStatusCrossMode = (store: WalletStore) => {
  const {
    im_margins: initialMarginPercentage,
    liquidation_risk: liquidationRisk,
    under_liquidation: underLiquidation,
  } = store.state.crossMarginChannel ?? {};

  const aggregateStatusCrossMode = getMarginModeAggregateStatus({
    liquidationRisk,
    underLiquidation,
    initialMarginPercentage,
  });

  return aggregateStatusCrossMode;
};

const selectWalletSpotPriceBySymbol = (spotSymbol: string) => (store: WalletStore) =>
  store.state.walletSpotPrice[spotSymbol];

const selectAllWalletSpotPriceObject = (store: WalletStore) =>
  store.state.walletSpotPrice;

// #endregion Reactive Data Selectors

export {
  // #region Non Reactive Selectors
  walletStoreSelector,
  walletSpotPriceBySymbolSelector,
  // #endregion

  // #region Reactive Selectors (use with useWalletStoreBase)
  selectMultiCollateralData,
  selectBlockedMarginCrossModeUsd,
  selectAvailableMarginCross,
  selectPortfolioMargin,
  selectCrossMargin,
  selectMarginModeAggregateStatusCrossMode,
  selectWalletSpotPriceBySymbol,
  selectAllWalletSpotPriceObject,
  // #endregion
};
